import { render, staticRenderFns } from "./ReportRangeSelectorLegend.vue?vue&type=template&id=5c15a073&"
import script from "./ReportRangeSelectorLegend.vue?vue&type=script&lang=js&"
export * from "./ReportRangeSelectorLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports